import styled from "styled-components";

export const IconSocial = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`

export const LinkSocial = styled.a`
    text-decoration: none;
    width: 53px;
    height: 53px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
`

export const LogoIconContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 20px;
    @media (max-width: 800px) {
        display: none;
    }
`